import { render, staticRenderFns } from "./ProductBrand.vue?vue&type=template&id=c98519d4"
import script from "./ProductBrand.vue?vue&type=script&lang=js"
export * from "./ProductBrand.vue?vue&type=script&lang=js"
import style0 from "./ProductBrand.vue?vue&type=style&index=0&id=c98519d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports